__turbopack_context__.v({
  "button": "xs5j5a_button",
  "buttonselected": "xs5j5a_buttonselected",
  "freeBox": "xs5j5a_freeBox",
  "slotTargetChildren": "xs5j5a_slotTargetChildren",
  "slotTargetChildrenselected": "xs5j5a_slotTargetChildrenselected",
});
